export default "__VITE_ASSET__BrOMal8L__"